import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useSupabaseUser,
} from "#imports";

export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser();

  // Giriş yapılmamışsa
  if (!user.value) {
    return navigateTo("/");
  }
});
